import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { createElement } from 'react';
import RadioButtonGroup from '../RadioButtonGroup/index.esm.js';
import { SegmentedControlContextProvider } from './context.esm.js';
export { default as ControlSegment } from './ControlSegment/index.esm.js';

function SegmentedControl(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      rest = _objectWithoutPropertiesLoose(props, ["size"]);

  return createElement(SegmentedControlContextProvider, {
    value: {
      size: size
    }
  }, createElement(RadioButtonGroup, _extends({
    backgroundColor: "bg-gray-200",
    spacing: "space-x-1",
    borderRadius: "rounded-md",
    padding: "p-0.5",
    inline: true
  }, rest)));
}

export default SegmentedControl;
//# sourceMappingURL=index.esm.js.map
